import React, {useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {Breadcrumbs, H5} from "../../../../../AbstractElements";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import SearchOptions from "../../../../CommonComponents/Search";
import WalletTransactionsTable from "../Component/WalletTransactionsTable";

const WalletTransactionIndex = () => {
    const [params, setParams] = useState<Record<string, unknown>>({});
    const [searchVisibility, setSearchVisibility] = useState<boolean>(false);
    const searchOptions = [
        {name: 'wallet_id', label: 'Wallet ID'},
        {name: 'owner_name', label: 'Owner'},
        {name: 'description'},
        {name: 'date'},
    ];

    return (
        <div>
            <Breadcrumbs mainTitle="Wallet Transactions" parent="Application" title="Wallet Transactions"/>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Wallet Transactions</H5>
                                <div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setSearchVisibility(!searchVisibility)
                                        }} type={'search'} permission={'read-wallet-transaction'}/>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {searchVisibility && <SearchOptions callBack={(searchParams: Record<string, unknown>) => setParams(searchParams)}
                                                                    searchOptions={searchOptions}/>}
                                <WalletTransactionsTable params={params}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WalletTransactionIndex;

